import { UpdateApPayeeInfoRequestApPayee } from 'ap-openapi';
import { FieldValues } from 'react-hook-form';

/**
 * Transform form data to UpdateApPayeeInfoRequestApPayee format
 * This function handles the transformation of flat form data into the nested structure
 * required by the updateApPayeeInfo API
 */
export const transformPayeeFormData = <TFormData extends FieldValues>(
  formData: TFormData
): UpdateApPayeeInfoRequestApPayee => {
  // Handle AI agent settings transformation
  // If invoice_download_agent_enabled exists, transform it to ai_agent_service_settings array
  if ('invoice_download_agent_enabled' in formData) {
    const { invoice_download_agent_enabled, ...rest } = formData;
    return {
      ...rest,
      ai_agent_service_settings: [
        {
          service_type: 'invoice_download_agent',
          is_enabled: invoice_download_agent_enabled,
        },
      ],
    };
  }

  // Handle transaction default value transformation
  // If any transaction-related fields exist, nest them under ap_invoice_transaction_default_value
  if (
    'name' in formData ||
    'dept_id' in formData ||
    'ap_item_id' in formData ||
    'project_code_id' in formData ||
    'is_tax_included' in formData ||
    'default_currency' in formData
  ) {
    const {
      name,
      dept_id,
      ap_item_id,
      project_code_id,
      is_tax_included,
      default_currency,
      ...rest
    } = formData;
    return {
      ...rest,
      ap_invoice_transaction_default_value: {
        name,
        dept_id,
        ap_item_id,
        project_code_id,
        is_tax_included,
        default_currency,
      },
    };
  }

  // Handle contact address settings transformation
  // If any address-related fields exist, nest them under ap_payee_contact_setting
  if (
    'postal_code' in formData ||
    'prefecture_id' in formData ||
    'address' in formData
  ) {
    const { postal_code, prefecture_id, address, ...rest } = formData;
    return {
      ...rest,
      ap_payee_contact_setting: {
        postal_code,
        prefecture_id,
        address,
      },
    };
  }

  return formData;
};
